import FLAG from 'config/flag.singleton';
import DELAY from 'constants/delay.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

const L = logger('setStateAfterRender');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const setStateAfterRender = (component, state, callback) => {
  if (USE_SPAM_LOG) L.debug('()', { component, state, callback });

  delayed(DELAY.workaround, () => void component.setState(state, callback));
};

// noinspection JSUnusedGlobalSymbols
export default setStateAfterRender;
